import { useState, useEffect } from "react";

interface ValidationResults {
  hasUpperCase: boolean;
  hasMinLength: boolean;
  hasLowerCase: boolean;
  hasNumber: boolean;
  hasSymbol: boolean;
}

const usePasswordValidation = (
  password: string | undefined,
): ValidationResults => {
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasMinLength, setHasMinLength] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSymbol, setHasSymbol] = useState(false);

  useEffect(() => {
    if (!password) {
      return;
    }

    // Check for uppercase
    setHasUpperCase(password.toLowerCase() !== password);

    // Check for minimum length
    setHasMinLength(password.length >= 8);

    // Check for lowercase
    setHasLowerCase(password.toUpperCase() !== password);

    // Check for a number
    setHasNumber(/\d/.test(password));

    // Check for a symbol
    setHasSymbol(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password));
     
  }, [password]);

  return { hasUpperCase, hasMinLength, hasLowerCase, hasNumber, hasSymbol };
};

export default usePasswordValidation;
